import {List} from 'semantic-ui-react';
export const ClueList = ({patterns,onListPatternClick,selectedPattern})=>{

    const listItems = patterns.map((p,index)=>{
        
        const classes = ['pattern-list-item'];
    
        if(selectedPattern === p) classes.push('selected');
    
        const className = classes.join(' ');
    
        return (        
        <List.Item key={index} className={className}
            onClick={()=>onListPatternClick(p)} >
            <p className="clue">{p.meaning}</p>
        </List.Item>
        )
    });

    return <List ordered>{listItems}</List>

};
